{
  "intro": "Как CloudServer обращается к Hetzner от имени проекта: токен, его права и когда последний раз копировался каталог.",
  "provider": "Провайдер",
  "permission": "Права",
  "permissionHint": "С правами «чтение и запись» CloudServer может менять ресурсы; с «только чтение» действия недоступны.",
  "catalogueHint": "Регионы, типы серверов, образы и цены копируются при подключении и затем каждые шесть часов.",
  "problem": {
    "active": "Последний запрос не удался",
    "failing": "Hetzner не ответил. CloudServer продолжает попытки; ваши ресурсы работают.",
    "revoked": "Hetzner отклонил токен. Создайте новый в проекте и замените его здесь."
  },
  "replace": "Заменить",
  "replaceLead": "Вставьте новый токен того же проекта Hetzner. Старый перестанет использоваться сразу.",
  "tokenReplaced": "Токен заменён",
  "rename": "Переименовать проект",
  "dangerTitle": "Удаление проекта",
  "dangerLead": "Касается только CloudServer, ресурсы в Hetzner не трогает.",
  "forgetLead": "Стирает токен и сохранённые данные. Чтобы перестать платить за ресурсы, удалите их до удаления проекта.",
  "adminOnly": "Менять токен, переименовывать и удалять проект могут только администраторы."
}
